import { render, staticRenderFns } from "./formAdd.vue?vue&type=template&id=45468841"
import script from "./formAdd.vue?vue&type=script&lang=js"
export * from "./formAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45468841')) {
      api.createRecord('45468841', component.options)
    } else {
      api.reload('45468841', component.options)
    }
    module.hot.accept("./formAdd.vue?vue&type=template&id=45468841", function () {
      api.rerender('45468841', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/kms_new/views/document_capture_log/form/components/formAdd.vue"
export default component.exports